export default __webpack_public_path__ + "src/assets/images/calc_app_standard-420a84d7.png";